import { RappiderAccordionComponent } from './components/accordion/accordion.component';
import { RappiderAddressCardComponent } from './components/address-card/address-card.component';
import { RappiderAlertComponent } from './components/alert/alert.component';
import { RappiderAvatarListWithTagComponent } from './components/avatar-list-with-tag/avatar-list-with-tag.component';
import { RappiderAvatarListComponent } from './components/avatar-list/avatar-list.component';
import { RappiderAvatarComponent } from './components/avatar/avatar.component';
import { RappiderBadgeComponent } from './components/badge/badge.component';
import { RappiderBannerSplitComponent } from './components/banner-split/banner-split.component';
import { RappiderBlockquoteComponent } from './components/blockquote/blockquote.component';
import { RappiderBreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { RappiderBrowseFileComponent } from './components/browse-file/browse-file.component';
import { RappiderButtonGroupComponent } from './components/button-group/button-group.component';
import { RappiderButtonComponent } from './components/button/button.component';
import { RappiderCallToActionComponent } from './components/call-to-action/call-to-action.component';
import { RappiderCardEightComponent } from './components/card-eight/card-eight.component';
import { RappiderCardElevenComponent } from './components/card-eleven/card-eleven.component';
import { RappiderCardFiveComponent } from './components/card-five/card-five.component';
import { RappiderCardFourComponent } from './components/card-four/card-four.component';
import { RappiderCardListComponent } from './components/card-list/card-list.component';
import { RappiderCardNineComponent } from './components/card-nine/card-nine.component';
import { RappiderCardSevenComponent } from './components/card-seven/card-seven.component';
import { RappiderCardSixComponent } from './components/card-six/card-six.component';
import { RappiderCardTenComponent } from './components/card-ten/card-ten.component';
import { RappiderCardThreeComponent } from './components/card-three/card-three.component';
import { RappiderCardTwelveComponent } from './components/card-twelve/card-twelve.component';
import { RappiderCardTwoComponent } from './components/card-two/card-two.component';
import { RappiderCardComponent } from './components/card/card.component';
import { RappiderCartItemComponent } from './components/cart-item/cart-item.component';
import { RappiderCheckboxListComponent } from './components/checkbox-list/checkbox-list.component';
import { RappiderCheckboxComponent } from './components/checkbox/checkbox.component';
import { RappiderColorPickerComponent } from './components/color-picker/color-picker.component';
import { RappiderCommentComponent } from './components/comment/comment.component';
import { RappiderCompareTableComponent } from './components/compare-table/compare-table.component';
import { RappiderCountdownComponent } from './components/countdown/countdown.component';
import { RappiderDatePickerComponent } from './components/date-picker/date-picker.component';
import { RappiderDatetimePickerComponent } from './components/datetime-picker/datetime-picker.component';
import { RappiderDimensionSelectComponent } from './components/dimension-select/dimension-select.component';
import { RappiderDividerComponent } from './components/divider/divider.component';
import { RappiderDropdownMenuComponent } from './components/dropdown-menu/dropdown-menu.component';
import { RappiderEditFormConfigInputComponent } from './components/edit-form-config-input/edit-form-config-input.component';
import { RappiderEditFormComponent } from './components/edit-form/edit-form.component';
import { RappiderEventListComponent } from './components/event-list/event-list.component';
import { RappiderFeedbackComponent } from './components/feedback/feedback.component';
import { RappiderGalleryGridComponent } from './components/gallery-grid/gallery-grid.component';
import { RappiderGenericListComponent } from './components/generic-list/generic-list.component';
import { RappiderGridContainerComponent } from './components/grid-container/grid-container.component';
import { RappiderHeadingComponent } from './components/heading/heading.component';
import { RappiderHeroComponent } from './components/hero/hero.component';
import { RappiderHtmlEditorComponent } from './components/html-editor/html-editor.component';
import { RappiderHtmlViewerComponent } from './components/html-viewer/html-viewer.component';
import { RappiderIconAndMenuListComponent } from './components/icon-and-menu-list/icon-and-menu-list.component';
import { RappiderIconBlockComponent } from './components/icon-block/icon-block.component';
import { RappiderIconPickerComponent } from './components/icon-picker/icon-picker.component';
import { RappiderIconComponent } from './components/icon/icon.component';
import { RappiderImageComponent } from './components/image/image.component';
import { RappiderInputErrorComponent } from './components/input-error/input-error.component';
import { RappiderInputGroupComponent } from './components/input-group/input-group.component';
import { RappiderInputLabelComponent } from './components/input-label/input-label.component';
import { RappiderInputValidatorInfoComponent } from './components/input-validator-info/input-validator-info.component';
import { RappiderJsonArrayComponent } from './components/json-array/json-array.component';
import { RappiderLabelComponent } from './components/label/label.component';
import { RappiderListFourComponent } from './components/list-four/list-four.component';
import { RappiderListGridConfigInputComponent } from './components/list-grid-config-input/list-grid-config-input.component';
import { RappiderListGridDataInputComponent } from './components/list-grid-data-input/list-grid-data-input.component';
import { RappiderListGridComponent } from './components/list-grid/list-grid.component';
import { RappiderListTwoComponent } from './components/list-two/list-two.component';
import { RappiderListComponent } from './components/list/list.component';
import { RappiderMenuComponent } from './components/menu/menu.component';
import { RappiderMessageOneComponent } from './components/message-one/message-one.component';
import { RappiderModalComponent } from './components/modal/modal.component';
import { RappiderNavigationBarComponent } from './components/navigation-bar/navigation-bar.component';
import { RappiderNewsBlockComponent } from './components/news-block/news-block.component';
import { RappiderNumberInputComponent } from './components/number-input/number-input.component';
import { RappiderPaginationComponent } from './components/pagination/pagination.component';
import { RappiderPanelComponent } from './components/panel/panel.component';
import { RappiderParagraphComponent } from './components/paragraph/paragraph.component';
import { RappiderPaymentSummaryComponent } from './components/payment-summary/payment-summary.component';
import { RappiderPricingPlanComponent } from './components/pricing-plan/pricing-plan.component';
import { RappiderProductPreviewCardComponent } from './components/product-preview-card/product-preview-card.component';
import { RappiderProductRecommendationsComponent } from './components/product-recommendations/product-recommendations.component';
import { RappiderProductComponent } from './components/product/product.component';
import { RappiderProgressOneComponent } from './components/progress-one/progress-one.component';
import { RappiderProgressComponent } from './components/progress/progress.component';
import { RappiderPromoComponent } from './components/promo/promo.component';
import { RappiderRadioGroupComponent } from './components/radio-group/radio-group.component';
import { RappiderRadioComponent } from './components/radio/radio.component';
import { RappiderRateDisplayComponent } from './components/rate-display/rate-display.component';
import { RappiderRateComponent } from './components/rate/rate.component';
import { RappiderReviewResultsComponent } from './components/review-results/review-results.component';
import { RappiderRichTextEditorComponent } from './components/rich-text-editor/rich-text-editor.component';
import { RappiderRowFormComponent } from './components/row-form/row-form.component';
import { RappiderSelectComponent } from './components/select/select.component';
import { RappiderSliderComponent } from './components/slider/slider.component';
import { RappiderStatisticComponent } from './components/statistic/statistic.component';
import { RappiderStringArrayComponent } from './components/string-array/string-array.component';
import { RappiderSubscribeSourceComponent } from './components/subscribe-source/subscribe-source.component';
import { RappiderSwitchComponent } from './components/switch/switch.component';
import { RappiderTabComponent } from './components/tab/tab.component';
import { RappiderTabsetComponent } from './components/tabset/tabset.component';
import { RappiderTagInputComponent } from './components/tag-input/tag-input.component';
import { RappiderTagComponent } from './components/tag/tag.component';
import { RappiderTeamBlockComponent } from './components/team-block/team-block.component';
import { RappiderTestimonialComponent } from './components/testimonial/testimonial.component';
import { RappiderTextComponent } from './components/text/text.component';
import { RappiderTextareaComponent } from './components/textarea/textarea.component';
import { RappiderTextboxComponent } from './components/textbox/textbox.component';
import { RappiderTimePickerComponent } from './components/time-picker/time-picker.component';
import { RappiderTimelineCardComponent } from './components/timeline-card/timeline-card.component';
import { RappiderTimelineComponent } from './components/timeline/timeline.component';
import { RappiderTitleBarComponent } from './components/title-bar/title-bar.component';
import { RappiderTitleImageComponent } from './components/title-image/title-image.component';
import { RappiderTitleComponent } from './components/title/title.component';
import { RappiderTreeGridComponent } from './components/tree-grid/tree-grid.component';
import { RappiderUploadFileComponent } from './components/upload-file/upload-file.component';
import { RappiderUserBlockComponent } from './components/user-block/user-block.component';
import { RappiderProductCardComponent } from './components/product-card/product-card.component';
import { RappiderPaymentDetailsComponent } from './components/payment-details/payment-details.component';
import { RappiderCardThirteenComponent } from './components/card-thirteen/card-thirteen.component';
import { RappiderImageLabelComponent } from './components/image-label/image-label.component';
import { RappiderDetailTableComponent } from './components/detail-table/detail-table.component';
import { RappiderLinkListComponent } from './components/link-list/link-list.component';
import { RappiderBannerComponent } from './components/banner/banner.component';
import { RappiderProductFeatureCardComponent } from './components/product-feature-card/product-feature-card.component';
import { RappiderLinkFooterComponent } from './components/link-footer/link-footer.component';
import { RappiderIconTextComponent } from './components/icon-text/icon-text.component';
import { RappiderShoppingCartComponent } from './components/shopping-cart/shopping-cart.component';
import { RappiderFormCardComponent } from './components/form-card/form-card.component';
import { RappiderCrudDetailComponent } from './components/crud-detail/crud-detail.component';
import { RappiderIconAndMenuListItemComponent }
  from './components/icon-and-menu-list/icon-and-menu-list-item/icon-and-menu-list-item.component';
import { RappiderDeliveredProductDetailComponent } from './components/delivered-product-detail/delivered-product-detail.component';
import { RappiderCalendarComponent } from './components/calendar/calendar.component';
import { RappiderImageGalleryComponent } from './components/image-gallery/image-gallery.component';
import { RappiderChatOneComponent } from './components/chat-one/chat-one.component';
import { RappiderCartPreviewComponent } from './components/cart-preview/cart-preview.component';
import { RappiderTitleToolbarComponent } from './components/title-toolbar/title-toolbar.component';
import { RappiderToolbarComponent } from './components/toolbar/toolbar.component';
import { RappiderProductOneComponent } from './components/product-one/product-one.component';
import { RappiderProductOneListComponent } from './components/product-one-list/product-one-list.component';
import { RappiderImageTimerComponent } from './components/image-timer/image-timer.component';
import { RappiderProfileCardComponent } from './components/profile-card/profile-card.component';
import { RappiderWeatherConditionComponent } from './components/weather-condition/weather-condition.component';
import { RappiderCarouselComponent } from './components/carousel/carousel.component';
import { RappiderCategoryListComponent } from './components/category-list/category-list.component';
import { RappiderLottiePlayerComponent } from './components/lottie-player/lottie-player.component';
import { RappiderAddressFormComponent } from './components/address-form/address-form.component';
import { RappiderCreditCardFormComponent } from './components/credit-card-form/credit-card-form.component';
import { RappiderCardOneComponent } from './components/card-one/card-one.component';
import { RappiderCardOneCarouselComponent } from './components/card-one-carousel/card-one-carousel.component';
import { RappiderLoginFormComponent } from './components/login-form/login-form.component';
import { RappiderCardCcsComponent } from './components/card-ccs/card-ccs.component';
import { RappiderSpinComponent } from './components/spin/spin.component';
import { RappiderCodemirrorInputFormComponent } from './components/codemirror-input-form/codemirror-input-form.component';
import { RappiderPageWrapperComponent } from './components/page-wrapper/page-wrapper.component';
import { RappiderCardOneListComponent } from './components/card-one-list/card-one-list.component';
import { RappiderNoteComponent } from './components/note/note.component';
import { RappiderKeyValueDisplayComponent } from './components/key-value-display/key-value-display.component';
import { RappiderNoteListComponent } from './components/note-list/note-list.component';
import { RappiderMediaPlayerComponent } from './components/media-player/media-player.component';
import { RappiderCodeEditorComponent } from './components/code-editor/code-editor.component';
import { RappiderPdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { RappiderCardFourteenComponent } from './components/card-fourteen/card-fourteen.component';
import { RappiderInputTemplateComponent } from './components/input-template/input-template.component';
import { RappiderTagListComponent } from './components/tag-list/tag-list.component';
import { RappiderHeroListComponent } from './components/hero-list/hero-list.component';
import { RappiderAutoCompleteComponent } from './components/auto-complete/auto-complete.component';
import { RappiderTestimonialListComponent } from './components/testimonial-list/testimonial-list.component';
import { RappiderSearchComponent } from './components/search/search.component';
import { RappiderAssetPickerComponent } from './components/asset-picker/asset-picker.component';
import { RappiderTimeNoticeCardComponent } from './components/time-notice-card/time-notice-card.component';
import { RappiderButtonListComponent } from './components/button-list/button-list.component';
import { RappiderAlternativeCarouselComponent } from './components/alternative-carousel/alternative-carousel.component';
import { RappiderDrawerComponent } from './components/drawer/drawer.component';
import { RappiderRowSelectComponent } from './components/row-select/row-select.component';
import { RappiderAlertListComponent } from './components/alert-list/alert-list.component';
import { RappiderUnorderedListOneComponent } from './components/unordered-list-one/unordered-list-one.component';
import { RappiderUnorderedListOneArrayComponent } from './components/unordered-list-one-array/unordered-list-one-array.component';
import { RappiderImageUploadComponent } from './components/image-upload/image-upload.component';
import { RappiderMenuSideComponent } from './components/menu-two/menu-side.component';
import { RappiderProfileCardTwoComponent } from './components/profile-card-two/profile-card-two.component';
import { RappiderInlineRowFormComponent } from './components/inline-row-form/inline-row-form.component';
import { RappiderMaterialSidenavComponent } from './components/material-sidenav/material-sidenav.component';
import { RappiderStripeComponent } from './components/stripe/stripe.component';
import { RappiderIconPickerTwoComponent } from './components/icon-picker-two/icon-picker-two.component';
import { RappiderShadowSettingsComponent } from './components/shadow-settings/shadow-settings.component';
import { RappiderSpacingComponent } from './components/spacing/spacing.component';
import { RappiderBorderSettingsComponent } from './components/border-settings/border-settings.component';
import { RappiderPhoneNumberInputComponent } from './components/phone-number-input/phone-number-input.component';
import { RappiderFontPickerComponent } from './components/font-picker/font-picker.component';
import { RappiderFontCardModule } from './components/font-card/font-card-module';
import { RappiderCardsComponent } from './components/cards/cards.component';
import { RappiderAssetBrowserComponent } from './components/asset-browser/asset-browser.component';
import { RappiderTreeSelectComponent } from './components/tree-select/tree-select.component';
import { RappiderListWrapperComponent } from './components/list-wrapper/list-wrapper.component';
import { RappiderCheckboxTableComponent } from './components/checkbox-table/checkbox-table.component';
import { RappiderJsonInputComponent } from './components/json-input/json-input.component';
import { RappiderIconPickerWrapperComponent } from './components/icon-picker-wrapper/icon-picker-wrapper.component';
import { RappiderChatComponent } from './components/chat/chat.component';
import { RappiderStepsComponent } from './components/steps/steps.component';
import { RappiderBackTopComponent } from './components/back-top/back-top.component';
import { RappiderCRUDModelDisplayComponent } from './components/crud-model-display/crud-model-display.component';
import { RappiderGoogleMapsComponent } from './components/google-maps/google-maps.component';
import { RappiderQRCodeComponent } from './components/qr-code/qr-code.component';
import { RappiderTransferComponent } from './components/transfer/transfer.component';
import { RappiderCascaderComponent } from './components/cascader/cascader.component';
import { RappiderEmailViewerComponent } from './components/email-viewer/email-viewer.component';
import { RappiderSkeletonComponent } from './components/skeleton/skeleton.component';
import { RappiderClickToDialComponent } from './components/click-to-dial/click-to-dial.component';
import { RappiderChartBaseComponent } from './components/chart-base/chart-base.component';
import { RappiderOverflowListComponent } from './components/overflow-list/overflow-list.component';
import { RappiderJsonEditorModalComponent } from './components/json-editor-modal/json-editor-modal.component';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const COMPONENTS_COLLECTION = {
  RappiderAccordionComponent: RappiderAccordionComponent,
  RappiderAddressCardComponent: RappiderAddressCardComponent,
  RappiderAlertComponent: RappiderAlertComponent,
  RappiderAvatarComponent: RappiderAvatarComponent,
  RappiderAvatarListComponent: RappiderAvatarListComponent,
  RappiderAvatarListWithTagComponent: RappiderAvatarListWithTagComponent,
  RappiderBadgeComponent: RappiderBadgeComponent,
  RappiderBannerSplitComponent: RappiderBannerSplitComponent,
  RappiderBannerComponent: RappiderBannerComponent,
  RappiderBlockquoteComponent: RappiderBlockquoteComponent,
  RappiderBreadcrumbComponent: RappiderBreadcrumbComponent,
  RappiderBrowseFileComponent: RappiderBrowseFileComponent,
  RappiderButtonComponent: RappiderButtonComponent,
  RappiderButtonGroupComponent: RappiderButtonGroupComponent,
  RappiderCallToActionComponent: RappiderCallToActionComponent,
  RappiderCardComponent: RappiderCardComponent,
  RappiderCardEightComponent: RappiderCardEightComponent,
  RappiderCardElevenComponent: RappiderCardElevenComponent,
  RappiderCardFiveComponent: RappiderCardFiveComponent,
  RappiderCardFourComponent: RappiderCardFourComponent,
  RappiderCardListComponent: RappiderCardListComponent,
  RappiderCardNineComponent: RappiderCardNineComponent,
  RappiderCardSevenComponent: RappiderCardSevenComponent,
  RappiderCardSixComponent: RappiderCardSixComponent,
  RappiderCardTenComponent: RappiderCardTenComponent,
  RappiderCardThreeComponent: RappiderCardThreeComponent,
  RappiderCardTwelveComponent: RappiderCardTwelveComponent,
  RappiderCardTwoComponent: RappiderCardTwoComponent,
  RappiderCartItemComponent: RappiderCartItemComponent,
  RappiderCheckboxComponent: RappiderCheckboxComponent,
  RappiderCheckboxListComponent: RappiderCheckboxListComponent,
  RappiderColorPickerComponent: RappiderColorPickerComponent,
  RappiderCommentComponent: RappiderCommentComponent,
  RappiderCompareTableComponent: RappiderCompareTableComponent,
  RappiderCountdownComponent: RappiderCountdownComponent,
  RappiderDatePickerComponent: RappiderDatePickerComponent,
  RappiderDatetimePickerComponent: RappiderDatetimePickerComponent,
  RappiderDimensionSelectComponent: RappiderDimensionSelectComponent,
  RappiderDividerComponent: RappiderDividerComponent,
  RappiderDropdownMenuComponent: RappiderDropdownMenuComponent,
  RappiderEventListComponent: RappiderEventListComponent,
  RappiderFeedbackComponent: RappiderFeedbackComponent,
  RappiderFontPickerComponent: RappiderFontPickerComponent,
  RappiderFontCardModule: RappiderFontCardModule,
  RappiderGalleryGridComponent: RappiderGalleryGridComponent,
  RappiderGenericListComponent: RappiderGenericListComponent,
  RappiderGridContainerComponent: RappiderGridContainerComponent,
  RappiderHeadingComponent: RappiderHeadingComponent,
  RappiderHeroComponent: RappiderHeroComponent,
  RappiderHtmlEditorComponent: RappiderHtmlEditorComponent,
  RappiderHtmlViewerComponent: RappiderHtmlViewerComponent,
  RappiderIconComponent: RappiderIconComponent,
  RappiderIconAndMenuListComponent: RappiderIconAndMenuListComponent,
  RappiderIconBlockComponent: RappiderIconBlockComponent,
  RappiderIconPickerComponent: RappiderIconPickerComponent,
  RappiderImageComponent: RappiderImageComponent,
  RappiderInputErrorComponent: RappiderInputErrorComponent,
  RappiderInputGroupComponent: RappiderInputGroupComponent,
  RappiderInputLabelComponent: RappiderInputLabelComponent,
  RappiderInputValidatorInfoComponent: RappiderInputValidatorInfoComponent,
  RappiderLabelComponent: RappiderLabelComponent,
  RappiderListComponent: RappiderListComponent,
  RappiderListFourComponent: RappiderListFourComponent,
  RappiderListTwoComponent: RappiderListTwoComponent,
  RappiderMenuComponent: RappiderMenuComponent,
  RappiderMessageOneComponent: RappiderMessageOneComponent,
  RappiderModalComponent: RappiderModalComponent,
  RappiderNavigationBarComponent: RappiderNavigationBarComponent,
  RappiderNewsBlockComponent: RappiderNewsBlockComponent,
  RappiderNumberInputComponent: RappiderNumberInputComponent,
  RappiderPaginationComponent: RappiderPaginationComponent,
  RappiderPanelComponent: RappiderPanelComponent,
  RappiderParagraphComponent: RappiderParagraphComponent,
  RappiderPaymentSummaryComponent: RappiderPaymentSummaryComponent,
  RappiderPricingPlanComponent: RappiderPricingPlanComponent,
  RappiderProductComponent: RappiderProductComponent,
  RappiderProductPreviewCardComponent: RappiderProductPreviewCardComponent,
  RappiderProductRecommendationsComponent: RappiderProductRecommendationsComponent,
  RappiderProgressComponent: RappiderProgressComponent,
  RappiderProgressOneComponent: RappiderProgressOneComponent,
  RappiderPromoComponent: RappiderPromoComponent,
  RappiderRadioComponent: RappiderRadioComponent,
  RappiderRadioGroupComponent: RappiderRadioGroupComponent,
  RappiderRateComponent: RappiderRateComponent,
  RappiderRateDisplayComponent: RappiderRateDisplayComponent,
  RappiderReviewResultsComponent: RappiderReviewResultsComponent,
  RappiderRichTextEditorComponent: RappiderRichTextEditorComponent,
  RappiderSelectComponent: RappiderSelectComponent,
  RappiderSliderComponent: RappiderSliderComponent,
  RappiderStatisticComponent: RappiderStatisticComponent,
  RappiderSubscribeSourceComponent: RappiderSubscribeSourceComponent,
  RappiderSwitchComponent: RappiderSwitchComponent,
  RappiderTabComponent: RappiderTabComponent,
  RappiderTabsetComponent: RappiderTabsetComponent,
  RappiderTagComponent: RappiderTagComponent,
  RappiderTagInputComponent: RappiderTagInputComponent,
  RappiderTeamBlockComponent: RappiderTeamBlockComponent,
  RappiderTestimonialComponent: RappiderTestimonialComponent,
  RappiderTextComponent: RappiderTextComponent,
  RappiderTextareaComponent: RappiderTextareaComponent,
  RappiderTextboxComponent: RappiderTextboxComponent,
  RappiderTimePickerComponent: RappiderTimePickerComponent,
  RappiderTimelineComponent: RappiderTimelineComponent,
  RappiderTimelineCardComponent: RappiderTimelineCardComponent,
  RappiderTitleComponent: RappiderTitleComponent,
  RappiderTitleBarComponent: RappiderTitleBarComponent,
  RappiderTitleImageComponent: RappiderTitleImageComponent,
  RappiderUploadFileComponent: RappiderUploadFileComponent,
  RappiderUserBlockComponent: RappiderUserBlockComponent,
  RappiderProductCardComponent: RappiderProductCardComponent,
  RappiderPaymentDetailsComponent: RappiderPaymentDetailsComponent,
  RappiderJsonArrayComponent: RappiderJsonArrayComponent,
  RappiderListGridComponent: RappiderListGridComponent,
  RappiderRowFormComponent: RappiderRowFormComponent,
  RappiderStringArrayComponent: RappiderStringArrayComponent,
  RappiderListGridDataInputComponent: RappiderListGridDataInputComponent,
  RappiderTreeGridComponent: RappiderTreeGridComponent,
  RappiderListGridConfigInputComponent: RappiderListGridConfigInputComponent,
  RappiderEditFormConfigInputComponent: RappiderEditFormConfigInputComponent,
  RappiderEditFormComponent: RappiderEditFormComponent,
  RappiderLinkListComponent: RappiderLinkListComponent,
  RappiderCardThirteenComponent: RappiderCardThirteenComponent,
  RappiderImageLabelComponent: RappiderImageLabelComponent,
  RappiderProductFeatureCardComponent: RappiderProductFeatureCardComponent,
  RappiderLinkFooterComponent: RappiderLinkFooterComponent,
  RappiderIconTextComponent: RappiderIconTextComponent,
  RappiderDetailTableComponent: RappiderDetailTableComponent,
  RappiderShoppingCartComponent: RappiderShoppingCartComponent,
  RappiderFormCardComponent: RappiderFormCardComponent,
  RappiderCrudDetailComponent: RappiderCrudDetailComponent,
  RappiderIconAndMenuListItemComponent: RappiderIconAndMenuListItemComponent,
  RappiderDeliveredProductDetailComponent: RappiderDeliveredProductDetailComponent,
  RappiderImageGalleryComponent: RappiderImageGalleryComponent,
  RappiderChatOneComponent: RappiderChatOneComponent,
  RappiderCartPreviewComponent: RappiderCartPreviewComponent,
  RappiderCalendarComponent: RappiderCalendarComponent,
  RappiderTitleToolbarComponent: RappiderTitleToolbarComponent,
  RappiderToolbarComponent: RappiderToolbarComponent,
  RappiderProductOneComponent: RappiderProductOneComponent,
  RappiderProductOneListComponent: RappiderProductOneListComponent,
  RappiderImageTimerComponent: RappiderImageTimerComponent,
  RappiderProfileCardComponent: RappiderProfileCardComponent,
  RappiderWeatherConditionComponent: RappiderWeatherConditionComponent,
  RappiderCarouselComponent: RappiderCarouselComponent,
  RappiderCategoryListComponent: RappiderCategoryListComponent,
  RappiderLottiePlayerComponent: RappiderLottiePlayerComponent,
  RappiderAddressFormComponent: RappiderAddressFormComponent,
  RappiderCreditCardFormComponent: RappiderCreditCardFormComponent,
  RappiderCardOneComponent: RappiderCardOneComponent,
  RappiderCardOneCarouselComponent: RappiderCardOneCarouselComponent,
  RappiderLoginFormComponent: RappiderLoginFormComponent,
  RappiderCardCcsComponent: RappiderCardCcsComponent,
  RappiderSpinComponent: RappiderSpinComponent,
  RappiderCodemirrorInputFormComponent: RappiderCodemirrorInputFormComponent,
  RappiderPageWrapperComponent: RappiderPageWrapperComponent,
  RappiderCardOneListComponent: RappiderCardOneListComponent,
  RappiderNoteComponent: RappiderNoteComponent,
  RappiderKeyValueDisplayComponent: RappiderKeyValueDisplayComponent,
  RappiderNoteListComponent: RappiderNoteListComponent,
  RappiderMediaPlayerComponent: RappiderMediaPlayerComponent,
  RappiderCodeEditorComponent: RappiderCodeEditorComponent,
  RappiderPdfViewerComponent: RappiderPdfViewerComponent,
  RappiderCardFourteenComponent: RappiderCardFourteenComponent,
  RappiderInputTemplateComponent: RappiderInputTemplateComponent,
  RappiderTagListComponent: RappiderTagListComponent,
  RappiderHeroListComponent: RappiderHeroListComponent,
  RappiderAutoCompleteComponent: RappiderAutoCompleteComponent,
  RappiderTestimonialListComponent: RappiderTestimonialListComponent,
  RappiderSearchComponent: RappiderSearchComponent,
  RappiderAssetPickerComponent: RappiderAssetPickerComponent,
  RappiderTimeNoticeCardComponent: RappiderTimeNoticeCardComponent,
  RappiderButtonListComponent: RappiderButtonListComponent,
  RappiderAlternativeCarouselComponent: RappiderAlternativeCarouselComponent,
  RappiderDrawerComponent: RappiderDrawerComponent,
  RappiderRowSelectComponent: RappiderRowSelectComponent,
  RappiderAlertListComponent: RappiderAlertListComponent,
  RappiderUnorderedListOneComponent: RappiderUnorderedListOneComponent,
  RappiderUnorderedListOneArrayComponent: RappiderUnorderedListOneArrayComponent,
  RappiderImageUploadComponent: RappiderImageUploadComponent,
  RappiderMenuSideComponent: RappiderMenuSideComponent,
  RappiderProfileCardTwoComponent: RappiderProfileCardTwoComponent,
  RappiderInlineRowFormComponent: RappiderInlineRowFormComponent,
  RappiderMaterialSidenavComponent: RappiderMaterialSidenavComponent,
  RappiderStripeComponent: RappiderStripeComponent,
  RappiderIconPickerTwoComponent: RappiderIconPickerTwoComponent,
  RappiderShadowSettingsComponent: RappiderShadowSettingsComponent,
  RappiderSpacingComponent: RappiderSpacingComponent,
  RappiderBorderSettingsComponent: RappiderBorderSettingsComponent,
  RappiderPhoneNumberInputComponent: RappiderPhoneNumberInputComponent,
  RappiderCardsComponent: RappiderCardsComponent,
  RappiderAssetBrowserComponent: RappiderAssetBrowserComponent,
  RappiderTreeSelectComponent: RappiderTreeSelectComponent,
  RappiderListWrapperComponent: RappiderListWrapperComponent,
  RappiderCheckboxTableComponent: RappiderCheckboxTableComponent,
  RappiderJsonInputComponent: RappiderJsonInputComponent,
  RappiderJsonEditorModalComponent: RappiderJsonEditorModalComponent,
  RappiderIconPickerWrapperComponent: RappiderIconPickerWrapperComponent,
  RappiderChatComponent: RappiderChatComponent,
  RappiderStepsComponent: RappiderStepsComponent,
  RappiderBackTopComponent: RappiderBackTopComponent,
  RappiderCRUDModelDisplayComponent: RappiderCRUDModelDisplayComponent,
  RappiderGoogleMapsComponent: RappiderGoogleMapsComponent,
  RappiderTransferComponent: RappiderTransferComponent,
  RappiderCascaderComponent: RappiderCascaderComponent,
  RappiderQRCodeComponent: RappiderQRCodeComponent,
  RappiderEmailViewerComponent: RappiderEmailViewerComponent,
  RappiderSkeletonComponent: RappiderSkeletonComponent,
  RappiderClickToDialComponent: RappiderClickToDialComponent,
  RappiderChartBaseComponent: RappiderChartBaseComponent,
  RappiderOverflowListComponent: RappiderOverflowListComponent
};
